export const initialPaginationState = {
    result:1,
    lastValues: [],
    //these first properties are for the character database. Then below is the comicDatabase
    currentPage: 1,
    offset:0,
    limit:24,//not used currently. hardcoded in grabDatabaseCharacters() bc it never changes dynamically
    currentLetter:'A',
    comicCurrentPage:1,
    comicOffset:0,
    comicCurrentLetter:'A'
}
//set the state to initialState here, only if nothing is passed
//the reducers hold the current state of whatever object you pass them. in this case 'initialGirlsState' 
export const paginationReducer = (state = initialPaginationState,action) => {
    switch(action.type){
////////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS
        case "CHANGE-CURRENT-PAGE":
        state = {
            ...state,//this will grab everything from the previous state
            currentPage: action.payload
        };
        return state;

        case "CHANGE-OFFSET":
        state = {
            ...state,//this will grab everything from the previous state
            offset: action.payload
        };
        return state;
       
        case "CHANGE-LETTER":
        state = {
            ...state,//this will grab everything from the previous state
            currentLetter: action.payload
        };
        return state;

////////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS
////////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS
////////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS

        case "COMIC-CHANGE-CURRENT-PAGE":
        state = {
            ...state,//this will grab everything from the previous state
            comicCurrentPage: action.payload
        };
        return state;

        case "COMIC-CHANGE-OFFSET":
        state = {
            ...state,//this will grab everything from the previous state
            comicOffset: action.payload
        };
        return state;
       
        case "COMIC-CHANGE-LETTER":
        state = {
            ...state,//this will grab everything from the previous state
            comicCurrentLetter: action.payload
        };
        return state;
    }
    //reducers always have to return some sort of state
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/paginationReducer.js